import cryptoWallet from "./crypto-wallet";

export default {
  cryptoWallet
}